import React, { useEffect, useRef, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import CheckoutPage from "../CheckoutPage/";
import MultiTermCheckoutPage from "../MultiTermCheckoutPage";
import useBillingPurchases from "../../hooks/useBillingPurchases";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },

  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  btnWrapper: {
    position: "relative",
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const ContactModal = ({ open, onClose, Invoice, contactId, initialValues, onSave, renewal = false }) => {
  const classes = useStyles();
  const isMounted = useRef(true);
  const [billingOptions, setBillingOptions] = useState(null);
  const [billingError, setBillingError] = useState(false);
  const { getOptions, getRenewalOptions } = useBillingPurchases();

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!open) return;
    let active = true;
    setBillingOptions(null);
    setBillingError(false);
    (renewal ? getRenewalOptions() : getOptions())
      .then(options => {
        if (active) setBillingOptions(options);
      })
      .catch(() => {
        if (active) setBillingError(true);
      });
    return () => {
      active = false;
    };
  }, [open, renewal]);

  const handleClose = () => {
    onClose();
  };

  return (
    <div className={classes.root}>
      <Dialog open={open} onClose={handleClose} maxWidth="md" scroll="paper">
        <DialogContent dividers>
          {!billingOptions && !billingError && <CircularProgress size={28} />}
          {billingError && (
            <Typography color="error">
              Nao foi possivel carregar as opcoes seguras de pagamento.
            </Typography>
          )}
          {billingOptions?.mode === "monthly_legacy" && (
            <CheckoutPage Invoice={Invoice} />
          )}
          {billingOptions?.mode === "monthly_managed" && (
            <Typography color="textSecondary">
              O plano mensal continua na mesma assinatura. Use a cobrança
              pendente exibida no histórico ou solicite revisão ao suporte.
            </Typography>
          )}
          {["multi_term", "manual_renewal"].includes(billingOptions?.mode) && (
            <MultiTermCheckoutPage
              options={billingOptions}
              renewal={billingOptions.mode === "manual_renewal"}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ContactModal;
